module.exports = __webpack_public_path__ + "static/media/Group 1.29a1f45d.png";